import Vue from 'vue'

/****
 * Import Icons from font awesome
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowCircleDown, faArrowCircleUp, faCheck,
  faFolderPlus, faGlobe, faIndustry, faLink, faSun, faTimesCircle, faUsers
} from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin, faGoogle, faFacebook, faDribbble } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import App from './App.vue'
import router from './router'
import store from './store'

library.add(
  faFolderPlus, faLink, faSun,
  faGithub, faLinkedin, faGoogle, faFacebook, faDribbble,
  faIndustry, faUsers, faGlobe, faTimesCircle,
  faArrowCircleUp, faArrowCircleDown, faCheck
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

// eslint-disable-next-line vue/require-name-property
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
